import React, { Component } from 'react';
import API from '../services/api';
import './MyProfile.css';
import AuthService from '../services/auth';
import { Link } from 'react-router-dom';
import diamond from '../static/vectors/gem-black.svg';
import USER_STATUSES from '../constants/userStatuses';

class MyProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        photos: [],
      },
    }
  }

  componentDidMount() {
    (new API()).get('/users/current',{}, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          user: response.user,
        });
      });
  }

  render() {
    const { user } = this.state;
    const profilePhoto = (user.photos.length > 0) ? user.photos.filter(el => el.profile === 1).pop() : {photoUrl: ''};
    return (
      <div className="my-profile">
        <div className="image" style={{'backgroundImage': `url('${profilePhoto.photoUrl}')` }}/>
        <div className="texts">
          {user.status >= USER_STATUSES.superior &&
          <div className="superior">
            <img src={diamond} alt={"diamond"} />
            SUPERIOR
          </div>}
          <div className="name">
            <Link to={`member/${user.name}`}>{`${user.name}`}</Link>
          </div>
          <div className="headline">
            {user.headline}
          </div>
        </div>
      </div>
    );
  }
}

export default MyProfile;


// WEBPACK FOOTER //
// ./src/components/MyProfile.js